module.exports = "http://cheyintong-website.oss-cn-beijing.aliyuncs.com/img/tools-vin@2x.png";